import { safeFetch } from '../utils/safeFetch';

const API_BASE = '/api/reservations';

export const getNotesByReservation = async (reservationId, token, tenant) => {
  const res = await safeFetch(
    `${API_BASE}/${reservationId}/notes`,
    {
      headers: {
        'Authorization': `Bearer ${token}`,
        'x-tenant-id':   tenant,
      },
    },
    `notes_${reservationId}`
  );
  return res.json();  // ← was missing, caused empty messages
};

export const createNote = async (reservationId, payload, token, tenant) => {
  const res = await safeFetch(
    `${API_BASE}/${reservationId}/notes`,
    {
      method: 'POST',
      headers: {
        'Content-Type':  'application/json',
        'Authorization': `Bearer ${token}`,
        'x-tenant-id':   tenant,
      },
      body: JSON.stringify(payload),
    },
    `notes_${reservationId}`
  );
  return res.json();
};